import type { PaginationProps } from '@patrianna/core-components'
import { useMediaQuery } from '@patrianna/shared-hooks'

import Pagination from 'components/Pagination'
import PaginationList from 'src/pageContainers/TransactionsPage/components/PaginationBlock/components/PaginationList'

import classes from './styles.module.scss'

type Props = {
  paginationProps: PaginationProps
  isShow: boolean
}

export default function PaginationBlock({ paginationProps, isShow }: Props) {
  const isMobile = useMediaQuery('sm')

  if (isShow) {
    return (
      <div className={classes.root} data-testid='pagination-block'>
        {!isMobile && <PaginationList {...paginationProps} />}
        <Pagination {...paginationProps} className={classes.mainPagination} />
      </div>
    )
  }

  return null
}
